import {
  ClipboardList, Search, FileText, CheckCircle2, Truck,
} from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useI18n } from "@/i18n";

const ICONS = [ClipboardList, Search, FileText, CheckCircle2, Truck];

export default function Process() {
  const { t } = useI18n();
  const steps = t("process.steps") || [];
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          testId="process-heading"
          eyebrow={t("process.eyebrow")}
          title={<>
            {t("process.title_a")}{" "}
            <span className="text-gradient-brand">{t("process.title_b")}</span>
            {t("process.title_dot")}
          </>}
          subtitle={t("process.subtitle")}
          align="center"
        />

        <div className="relative mt-16">
          <div className="hidden lg:block absolute top-[44px] left-[8%] right-[8%] h-px shimmer-line" />
          <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {steps.map((s, i) => {
              const Icon = ICONS[i] || ClipboardList;
              return (
                <li key={i} data-testid={`process-step-${i}`} className="reveal" style={{ transitionDelay: `${i * 90}ms` }}>
                  <div className="glass-card rounded-2xl p-6 h-full relative">
                    <div className="flex items-center justify-between mb-5">
                      <div className="icon-bubble"><Icon className="w-5 h-5" /></div>
                      <span className="font-display text-[42px] font-extrabold leading-none text-white/10">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="font-display text-[16.5px] font-semibold tracking-tight text-white">{s.title}</h3>
                    <p className="mt-2 text-[13.5px] text-[#A8A8B3] leading-relaxed">{s.body}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
